import React from 'react';
import { WebsiteDesignProps } from './types';
import { Aperture, Plus, ArrowUpRight } from 'lucide-react';
import { Button } from "@/components/ui/button";

const GlassCampus: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Aura Academy";

    return (
        <div className="bg-[#e0e5ec] min-h-screen font-sans overflow-hidden relative">
            {/* Background Gradients */}
            <div className="fixed top-[-20%] right-[-10%] w-[800px] h-[800px] bg-purple-400 rounded-full mix-blend-multiply filter blur-[120px] opacity-40 animate-blob"></div>
            <div className="fixed bottom-[-20%] left-[-10%] w-[800px] h-[800px] bg-blue-400 rounded-full mix-blend-multiply filter blur-[120px] opacity-40 animate-blob animation-delay-2000"></div>
            <div className="fixed top-[20%] left-[20%] w-[600px] h-[600px] bg-pink-400 rounded-full mix-blend-multiply filter blur-[120px] opacity-40 animate-blob animation-delay-4000"></div>

            <nav className="relative z-50 flex justify-center py-6">
                <div className="bg-white/30 backdrop-blur-md border border-white/40 shadow-lg rounded-full px-8 py-4 flex items-center gap-8">
                     <span className="font-bold text-gray-800 text-lg flex items-center gap-2">
                         <Aperture size={20} className="text-blue-600" /> {schoolName}
                     </span>
                     <div className="hidden md:flex gap-6 text-sm font-medium text-gray-700">
                         <a href="#" className="hover:text-blue-600">Academics</a>
                         <a href="#" className="hover:text-blue-600">Campus</a>
                         <a href="#" className="hover:text-blue-600">Life</a>
                     </div>
                     <Button className="rounded-full bg-blue-600/90 hover:bg-blue-700 text-white shadow-lg backdrop-blur text-xs px-6">
                         Portal
                     </Button>
                </div>
            </nav>

            <main className="container mx-auto px-6 pt-12 pb-20 relative z-10">
                <div className="flex flex-col items-center text-center max-w-4xl mx-auto mb-16">
                    <h1 className="text-6xl md:text-8xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-600 via-purple-600 to-pink-600 mb-8 tracking-tight drop-shadow-sm">
                        Experience Clarity.
                    </h1>
                    <p className="text-xl text-gray-600 mb-10 max-w-2xl">
                        A modern educational environment where transparency meets transformation. 
                    </p>
                    <div className="flex gap-4">
                        <div className="p-1 bg-gradient-to-r from-blue-500 to-purple-500 rounded-xl shadow-xl">
                            <Button className="bg-white/90 hover:bg-white text-gray-900 rounded-lg h-12 px-8 font-bold backdrop-blur">
                                Virtual Tour
                            </Button>
                        </div>
                    </div>
                </div>

                {/* Glass Cards */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                     <div className="bg-white/20 backdrop-blur-lg border border-white/30 p-8 rounded-3xl shadow-xl hover:bg-white/30 transition-all cursor-pointer group">
                          <div className="w-12 h-12 bg-white/50 rounded-2xl flex items-center justify-center mb-6 shadow-inner text-blue-600">
                              <Plus size={24} />
                          </div>
                          <h3 className="text-2xl font-bold text-gray-800 mb-2">Innovative</h3>
                          <p className="text-gray-600 mb-6">Curriculum designed for the 22nd century learner.</p>
                          <div className="flex items-center text-blue-700 font-bold text-sm opacity-0 group-hover:opacity-100 transition-opacity">
                              Learn More <ArrowUpRight size={14} className="ml-1" />
                          </div>
                     </div>

                     <div className="md:col-span-2 bg-white/20 backdrop-blur-lg border border-white/30 rounded-3xl shadow-xl overflow-hidden relative group">
                          <img src="https://images.unsplash.com/photo-1523050854058-8df90110c9f1?q=80&w=2070&auto=format&fit=crop" className="w-full h-full object-cover opacity-80 group-hover:scale-105 transition-transform duration-700" alt="Students" />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent flex items-end p-8">
                               <div className="text-white">
                                   <div className="text-sm font-bold uppercase tracking-wider mb-2 opacity-80">Student Life</div>
                                   <h3 className="text-3xl font-bold">A Vibrant Community</h3>
                               </div>
                          </div>
                     </div>
                </div>
            </main>
        </div>
    );
};

export default GlassCampus;
